import { proxy } from 'valtio';
import { CallState, DialerState } from './types';

export const callState = proxy<CallState>({
  connected: false,
  callId: '',
  direction: '',
  ended: false,
  established: false,
  hasSession: false,
  held: false,
  inTransfer: false,
  isAudioMuted: false,
  isVideoMuted: false,
  localIdentity: '',
  originating: false,
  primary: false,
  progress: false,
  remoteIdentity: '',
  terminating: false,
  registrationFailed: false,
  internalCall: false,
  remoteCallId: '',
  lastTriggeringEvent: '',
  pcsConversationSid: '',
  queueIds: [],
});

export const dialerState = proxy<DialerState>({
  actionDisplay: '',
  actionColor: '#093',
  dialedNumbers: '',
});
